<template lang="pug">
.top-bar__user-info
  .top-bar__user-info-name(
    v-if="user"
    @click="toggleMenuVisibility"
  )
    span {{ user.display_name }}
    img.dropdown(
      src="../assets/icons/dropdown.png"
    )
    div(
      class="account"
      :class="{account_active: accountIsActive }"
    )
  .top-bar__user-info-menu-wrapper(
    ref="wrapperUserMenu"
    @click="closeUserMenu"
    v-show="userMenuVisible"
  )
  .top-bar__user-info-menu(
    v-show="userMenuVisible"
  )
    .top-bar__user-info-menu-item(
      @click="logOut"
    )
      img(
        src="../assets/icons/exit.png"
      )
      span Выйти
</template>

<script>
import { mapState } from 'vuex';
import {
  LOGOUT,
} from '../constants';

export default {
  name: 'TheAccount',

  data() {
    return {
      userMenuVisible: false,
    };
  },

  computed: {
    ...mapState({
      user: state => state.user,
    }),

    accountIsActive() {
      return this.userMenuVisible;
    },
  },

  methods: {
    toggleMenuVisibility() {
      this.userMenuVisible = !this.userMenuVisible;
    },

    logOut() {
      return this.$store.dispatch(LOGOUT);
    },

    closeUserMenu(event) {
      const wrapper = this.$refs.wrapperUserMenu;
      const isWrapper = wrapper === event.target;

      const userMenuIsVisible = this.userMenuVisible === true;

      if (isWrapper && userMenuIsVisible) {
        this.toggleMenuVisibility();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .top-bar {
    height: 56px;
    margin-bottom: 32px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.16);
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 2;

    @include mobile {
      margin-bottom: 17px;
    }
  }

  .top-bar__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1200px;
    min-width: 320px;
    margin: 0 auto;
    height: 100%;

    @include mobile {
      justify-content: flex-start;
    }
  }

  .top-bar__title {
    font-size: 24px;
    letter-spacing: 0.7px;

    a {
      color: black;
      text-decoration: none;
    }

    @include mobile {
      display: none;
    }
  }

  .top-bar__user-info {
    position: relative;

    @include mobile {
      margin-left: auto;
      margin-right: 0;
    }
  }

  .top-bar__user-info-name {
    cursor: pointer;
    display: flex;

    span {
      font-weight: 500;
      font-size: 14px;
      letter-spacing: 0.7px;
      user-select: none;
      line-height: normal;
      color: black;
    }

    .dropdown {
      width: 24px;
      height: 20px;
      margin-top: 1px;
    }

    @include mobile {
      span {
        display: none;
      }
      .dropdown {
        display: none;
      }
    }
  }

  .top-bar__user-info-menu {
    position: absolute;
    width: 231px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.5);
    background-color: white;
    top: 24px;
    right: -3px;
    z-index: 200;

    @include mobile {
      top: 25px;
      right: 5%;
    }
  }

  .top-bar__user-info-menu-item {
    height: 50px;
    line-height: 50px;
    padding-left: 20px;
    background: white;
    cursor: pointer;
    display: flex;
    align-items: center;

    img {
      width: 20px;
      margin-right: 15px;
    }

    span {
      font-size: 14px;
      letter-spacing: 0.39px;
    }

    @include hover {
      background: #ebebeb;
    }
  }

  .account {
    display: none;

    @include mobile {
      display: block;
      width: 20px;
      height: 20px;
      background: url("../assets/icons/account.png");
      background-size: cover;
    }

    &_active {
      @include mobile {
        background: url("../assets/icons/account-hover.png");
        background-size: cover;
        z-index: 110;
      }
    }
  }

  .top-bar__item-label {
    display: none;

    @include mobile {
      display: inline-block;
      font-size: 20px;
    }
  }

  .menu-show-toggle {
    display: none;

    @include mobile {
      display: block;
      width: 18px;
      height: 12px;
      cursor: pointer;
      background-size: cover;
      border: none;
    }
  }

  .menu-show-toggle-wrapper {
    padding: 20px 6.25%;
  }

  .top-bar__user-info-menu-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    min-width: 320px;
    z-index: 100;
    width: 100%;
    height: 100%;
  }

  .top-bar__item-label_user {
    margin-left: 7%;
  }
</style>



// WEBPACK FOOTER //
// src/components/TheAccount.vue